import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LaporanPage from './LaporanPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LaporanPage />
  </React.StrictMode>
);
